import { useState } from "react";

const API = process.env.REACT_APP_API_URL;

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res  = await fetch(`${API}/api/auth/login`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Login failed");
      onLogin(data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#f4f7f9"
    }}>
      <div style={{
        background: "#fff", borderRadius: 12, padding: "40px 48px",
        boxShadow: "0 2px 16px rgba(0,0,0,0.10)", minWidth: 340
      }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 26, fontWeight: 700, color: "#0a3d22" }}>Bio-EV</div>
          <div style={{ fontSize: 13, color: "#4a8a6a", marginTop: 4 }}>Vendor Portal</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <input
              type="text" placeholder="Username" value={username}
              onChange={e => setUsername(e.target.value)}
              style={{ width: "100%", padding: "10px 14px", borderRadius: 8,
                border: "1px solid #d8ead2", fontSize: 14, boxSizing: "border-box" }}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <input
              type="password" placeholder="Password" value={password}
              onChange={e => setPassword(e.target.value)}
              style={{ width: "100%", padding: "10px 14px", borderRadius: 8,
                border: "1px solid #d8ead2", fontSize: 14, boxSizing: "border-box" }}
            />
          </div>
          {error && <div style={{ color: "#c0392b", fontSize: 13, marginBottom: 14 }}>{error}</div>}
          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "12px", background: "#0a3d22", color: "#fff",
            border: "none", borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: "pointer"
          }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}